import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthHeaders } from "../../../../components/Token";
import { API_BASE_URL } from "../../../../utils/index";

import EditNewProductsFields from "./EditNewProductsFields";
import CancelButton from "../../../../components/MinorComponents/CancelButton";
import { UpdateVendor } from "../../../../services/api/Vendor";

// ✅ MUI Imports
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
  Paper
} from "@mui/material";

function EditVendorNewProducts() {
  const { _id } = useParams();
  const navigate = useNavigate();
  const headers = useAuthHeaders();
  const subdomain = localStorage.getItem("vendorsubdomain");

  const [productPartNumberEdit, setProductPartNumberEdit] = useState("");
  const [existingImages, setExistingImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [newImagesPreview, setNewImagesPreview] = useState([]);
  const [currentCategories, setCurrentCategories] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [sumbitCategory, setSumbitCategory] = useState("");
  const [subCategoryId, setSubCategoryId] = useState([]);
  const [currentSubCategories, setCurrentSubCategories] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [sumbitSubCategory, setSumbitSubCategory] = useState("");
  const [manuFacturerEdit, setManuFacturerEdit] = useState("");
  const [oldAmount, setOldAmount] = useState();
  const [salePrice, setSalelPrice] = useState("");
  const [weightPerPiece, setWeightPerPiece] = useState("");
  const [boxOfQuantity, setBoxOfQuantity] = useState("");
  const [originalPrice, setOriginalPrice] = useState("");
  const [productWeight, setProductWeight] = useState("");
  const [products, setProducts] = useState("");
  const [quantity, setQuantity] = useState("");
  const [metaTitle, setmetaTitle] = useState("");
  const [dealofDay, setDealofDay] = useState(false);
  const [currentApidata, setCurrentApidata] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [writeNotes, setWriteNotes] = useState("");
  const [descriptions, setDescriptions] = useState([]);
  const [discriptionType, setDiscriptionType] = useState("");
  const [selectDiscriptionType, setSelectDiscriptionType] = useState([]);
  const [updatedDescriptions, setUpdatedDescriptions] = useState([]);
  const [manualInput, setManualInput] = useState([{}]);
  const [loading, setLoading] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/admin/products/adminsingleproduct/${_id}`)
      .then((res) => {
        const data = res.data.product;
        setProductPartNumberEdit(data.partNumber);
        setExistingImages(data.productimages);
        setCurrentCategories(data.category);
        setSelectedCategory(data.category);
        setSubCategoryId(data?.subcategoryname?._id);
        setCurrentSubCategories(data.subcategoryname);
        setSelectedSubCategory(data.subcategoryname);
        setManuFacturerEdit(data.manufacturer);
        setOldAmount(data?.oldprice);
        setSalelPrice(data.saleprice);
        setWeightPerPiece(data.weightperpiece);
        setBoxOfQuantity(data.boq);
        setOriginalPrice(data?.Productprice);
        setProductWeight(data?.productweight);
        setProducts(data.product);
        setQuantity(data.quantity);
        setmetaTitle(data.metatitle);
        setDealofDay(data.dealofday);
        setCurrentApidata(data.dealExpiryDate);
        setWriteNotes(data.writenotes);
        const dateObject = data.dealExpiryDate && new Date(data.dealExpiryDate);
        setSelectedDate(dateObject);
        const initialDescriptions = data.descriptions || [];
        setDescriptions(initialDescriptions);
        setUpdatedDescriptions(initialDescriptions.map((desc) => desc.value));
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/category/admin/getcategory`, { headers })
      .then((res) => setCategories(res.data.categories))
      .catch((err) => console.error("Error fetching category data:", err));
  }, []);

  useEffect(() => {
    if (subCategoryId) {
      axios
        .get(`${API_BASE_URL}/admin/getdescriptionnametypesbysubcategory/${subCategoryId}`)
        .then((res) => {
          // console.log(res.data.descriptionnames);
        })
        .catch((err) => console.error("Error fetching subcategory data:", err));
    }
  }, [subCategoryId]);

  const onImagesChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setNewImagesPreview((prev) => [...prev, reader.result]);
          setNewImages((prev) => [...prev, file]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const removeExistingImage = (index) => {
    const imageToRemove = existingImages[index].productimage;
    axios
      .delete(`${API_BASE_URL}/products/${_id}/images`, {
        headers,
        data: { imageUrl: imageToRemove },
      })
      .then(() => {
        setExistingImages((prev) => prev.filter((_, i) => i !== index));
      })
      .catch(console.error);
  };

  const removeNewImage = (index) => {
    setNewImagesPreview((prev) => prev.filter((_, i) => i !== index));
    setNewImages((prev) => prev.filter((_, i) => i !== index));
    const input = document.getElementById("productimages");
    if (input) input.value = null;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    const data = {
      partNumber: productPartNumberEdit,
      manufacturer: manuFacturerEdit,
      weightperpiece: weightPerPiece,
      productweight: productWeight,
      boq: boxOfQuantity,
      Productprice: originalPrice,
      product: products,
      saleprice: salePrice,
      quantity: quantity,
      metatitle: metaTitle,
      writenotes: writeNotes,
      dealofday: dealofDay,
      oldprice: oldAmount,
      // dealExpiryDate: selectedDate,
      category: sumbitCategory.length > 0 ? sumbitCategory.name : currentCategories.name,
      subcategoryname: sumbitSubCategory.length > 0 ? sumbitSubCategory.name : currentSubCategories.name,
    };

    if (dealofDay && selectedDate) {
      data.dealExpiryDate = selectedDate;
    }
    if (Object.keys(updatedDescriptions).length > 0) {
      data.descriptions = updatedDescriptions?.map((value, index) => ({
        name: descriptions[index].name,
        value,
      }));
    } else {
      const formattedDescriptions = Object.entries(selectDiscriptionType).map(
        ([name, value]) => ({
          name: name ?? "Default Name",
          value: value ?? "Default Value",
        })
      );

      const validManualInputs = manualInput.filter((input) =>
        input && typeof input === "object" &&
        Object.values(input).some((v) => v.trim() !== "")
      );

      const formattedManual = validManualInputs.map((item) => ({
        name: Object.keys(item)[0] || "Default Name",
        value: Object.values(item)[0] || "Default Value",
      }));

      data.descriptions = [...formattedDescriptions, ...formattedManual];
    }

    if (newImages) {
      data.productImage = newImages;
      newImages.forEach((img) => {
        formData.append("productimages", img);
      });
    }

    Object.keys(data).forEach((key) => {
      if (key === "descriptions") {
        data.descriptions.forEach((desc, index) => {
          formData.append(`descriptions[${index}][name]`, desc.name);
          formData.append(`descriptions[${index}][value]`, desc.value);
        });
      } else {
        formData.append(key, data[key]);
      }
    });

    try {
      setLoading(true);
      const response = await UpdateVendor(subdomain, formData, _id);
      if (response.success) {
        console.log(response, "resposne")
        showSnackbar(response.message);
        navigate(`/${subdomain}/products`);
      } else {
        console.log(response, "response")
        showSnackbar(response.data.message, "error");
      }
    } catch (err) {
      // console.log(error)
      showSnackbar("Something went wrong!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCategorySelect = (e) => {
    const id = e.target.value;
    setSelectedCategory(id);
    const findCat = categories.find((c) => c._id === id);
    setSumbitCategory(findCat.name);

    axios.get(`${API_BASE_URL}/category/admin/${id}`)
      .then((res) => setSubCategory(res.data.subcategoryNames))
      .catch((err) => console.error("Subcategory fetch error", err));
  };

  const handleSubCategorySelect = (e) => {
    const id = e.target.value;
    setSelectedSubCategory(id);
    const found = subCategory.find((s) => s._id === id);
    setSumbitSubCategory(found.name);

    axios.get(`${API_BASE_URL}/admin/getdescriptionnametypesbysubcategory/${id}`)
      .then((res) => setDiscriptionType(res?.data?.descriptionnames))
      .catch((err) => console.error("Description fetch error", err));
  };

  const handleChange = (ele) => {
    const { name, value } = ele.target;
    setSelectDiscriptionType((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>Edit Product</Typography>
      <form onSubmit={handleSave} className="category"
        style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset" }}>
        <EditNewProductsFields
          productPartNumberEdit={productPartNumberEdit}
          setProductPartNumberEdit={setProductPartNumberEdit}
          productId={_id}
          existingImages={existingImages}
          newImagesPreview={newImagesPreview}
          onImagesChange={onImagesChange}
          removeExistingImage={removeExistingImage}
          removeNewImage={removeNewImage}
          currentCategories={currentCategories}
          categories={categories}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          handleCategorySelect={handleCategorySelect}
          currentSubCategories={currentSubCategories}
          subCategory={subCategory}
          selectedSubCategory={selectedSubCategory}
          setSelectedSubCategory={setSelectedSubCategory}
          handleSubCategorySelect={handleSubCategorySelect}
          manuFacturerEdit={manuFacturerEdit}
          setManuFacturerEdit={setManuFacturerEdit}
          oldAmount={oldAmount}
          setOldAmount={setOldAmount}
          setSalelPrice={setSalelPrice}
          salePrice={salePrice}
          weightPerPiece={weightPerPiece}
          setWeightPerPiece={setWeightPerPiece}
          boxOfQuantity={boxOfQuantity}
          setBoxOfQuantity={setBoxOfQuantity}
          originalPrice={originalPrice}
          setOriginalPrice={setOriginalPrice}
          productWeight={productWeight}
          setProductWeight={setProductWeight}
          products={products}
          setProducts={setProducts}
          quantity={quantity}
          setQuantity={setQuantity}
          metaTitle={metaTitle}
          setmetaTitle={setmetaTitle}
          setDealofDay={setDealofDay}
          dealofDay={dealofDay}
          currentApidata={currentApidata}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          writeNotes={writeNotes}
          setWriteNotes={setWriteNotes}
          descriptions={descriptions}
          setUpdatedDescriptions={setUpdatedDescriptions}
          updatedDescriptions={updatedDescriptions}
          discriptionType={discriptionType}
          handleChange={handleChange}
          setManualInput={setManualInput}
          manualInput={manualInput}
        />

        <Box display="flex" gap={2} mt={3}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            startIcon={loading && <CircularProgress size={20} color="inherit" />}
          >
            {loading ? "Saving..." : "Save"}
          </Button>
          <Button
            onClick={() => navigate(`/${subdomain}/products`)}
            variant="contained"
            color="error"


          >
            Close
          </Button>


        </Box>
      </form>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default EditVendorNewProducts;
